(() => {
  if (window.NavelisRecentlyViewed) return;

  const storageKey =
    document.querySelector('[data-recent-products]')?.dataset.storageKey || 'navelis:recent-products';
  const currentHandle = document.body.dataset.productHandle || '';
  const currentId = document.body.dataset.productId || '';
  const rootUrl = () => window.Shopify?.routes?.root || '/';

  const read = () => {
    try {
      const stored = JSON.parse(localStorage.getItem(storageKey) || '[]');
      return Array.isArray(stored) ? [...new Set(stored.filter((handle) => typeof handle === 'string' && handle.length))].slice(0, 12) : [];
    } catch (_error) {
      return [];
    }
  };

  const writeCurrent = () => {
    if (!currentHandle) return;
    try {
      const handles = [currentHandle, ...read().filter((handle) => handle !== currentHandle)].slice(0, 12);
      localStorage.setItem(storageKey, JSON.stringify(handles));
    } catch (_error) {
      // Storage can be disabled by visitor privacy settings; the section stays hidden.
    }
  };

  const fetchCard = async (handle, sectionId) => {
    const url = new URL(`${rootUrl()}products/${encodeURIComponent(handle)}`, window.location.origin);
    url.searchParams.set('section_id', sectionId);
    const response = await fetch(url, { headers: { Accept: 'text/html' } });
    if (!response.ok) return null;

    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const card = html.querySelector('[data-recent-product-card]');
    if (!card || (currentId && card.dataset.productId === currentId)) return null;
    return card;
  };

  const initialize = async (section) => {
    if (!section || section.dataset.recentProductsReady === 'true') return;
    section.dataset.recentProductsReady = 'true';

    const list = section.querySelector('[data-recent-products-list]');
    const limit = Math.min(12, Math.max(2, Math.floor(Number(section.dataset.limit) || 4)));
    const handles = read().filter((handle) => handle !== currentHandle).slice(0, limit);
    if (!list || handles.length === 0) return;

    try {
      const results = await Promise.allSettled(handles.map((handle) => fetchCard(handle, section.dataset.cardSection)));
      const cards = results.filter((result) => result.status === 'fulfilled' && result.value).map((result) => result.value);
      if (cards.length === 0) return;
      cards.forEach((card) => {
        const item = document.createElement('div');
        item.setAttribute('role', 'listitem');
        item.append(card);
        list.append(item);
      });
      section.hidden = false;
    } catch (_error) {
      section.hidden = true;
    }
  };

  const initializeAll = () => document.querySelectorAll('[data-recent-products]').forEach(initialize);
  initializeAll();
  writeCurrent();

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-recent-products]').forEach(initialize);
  });

  window.NavelisRecentlyViewed = { initialize };
})();
